import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';
import { PageEnum } from '/@/enums/pageEnum';

const projectStatementCreate: AppRouteModule = {
  path: `${PageEnum.PROJECT_STATEMENT_CREATE}/:prjId`,
  name: 'ProjectStatementCreateRoot',
  component: LAYOUT,
  meta: {
    title: '新建服务结算单',
    hideMenu: true,
  },
  children: [
    {
      path: '',
      name: 'ProjectStatementCreate',
      component: () => import('/@/views/project/createStatement.vue'),
      meta: {
        title: '新建服务结算单',
        hideMenu: true,
        currentActiveMenu: '/project/list',
      },
    },
  ],
};

export default projectStatementCreate;
